import type { EnumUnion } from '@dresscode-frontend/utility-types';

/**
 * 専門資格一覧のソート可能なカラム
 */
export const SpecialtyCertificationOrderBy = {
  CERTIFICATION_NAME: 'CERTIFICATION_NAME',
  CERTIFICATION_CODE: 'CERTIFICATION_CODE',
  SPECIALTY_CATEGORY_NAME: 'SPECIALTY_CATEGORY_NAME',
  SPECIALTY_LEVEL_NAME: 'SPECIALTY_LEVEL_NAME',
  ISSUING_ORGANIZATION_NAME: 'ISSUING_ORGANIZATION_NAME',
  CERTIFICATIONS_HOLDERS_COUNT: 'CERTIFICATIONS_HOLDERS_COUNT'
} as const satisfies Record<string, string>;
export type SpecialtyCertificationOrderBy = EnumUnion<typeof SpecialtyCertificationOrderBy>;

/**
 * テーブルカラムの定義
 */
export const SpecialtyCertificationTableColumns = {
  specialtyName: 'specialtyName',
  specialtyCertificationCode: 'specialtyCertificationCode',
  specialtyCategoryName: 'specialtyCategoryName',
  specialtyLevelName: 'specialtyLevelName',
  issuingOrganizationName: 'issuingOrganizationName',
  certificationsHoldersCount: 'certificationsHoldersCount'
} as const;
export type SpecialtyCertificationTableColumns = (typeof SpecialtyCertificationTableColumns)[keyof typeof SpecialtyCertificationTableColumns];